module.exports = {
  pixKeyType: {
    description: 'tipo de chave'
  },
  pixKey: {
    description: 'chave pix'
  },
  value: {
    description: 'valor'
  },
  email: {
    description: 'email',
    optional: true
  },
  cpfCnpj: {
    description: 'cpf ou cnpj',
    optional: true
  },
  integrationId: {
    description: 'id integracao',
    optional: true
  },
  pixDescription: {
    description: 'descricao pix',
    optional: true
  },
  paymentDate: {
    description: 'data de agendamento',
    optional: true
  }
};
